var Parallax = {
    amplitude_scale: 0.05,
    amplitude_mvt_block:200,
    init: function () {


        $(window).scroll(function () {
            Parallax.scroll();
        })

        $(window).resize(function () {
            Parallax.resize();
        });
        Parallax.resize();

        $("[parallax]").addClass("initialized");
    },
    resize: function () {
        /*
        $('[parallax]').each(function () {

        })
        */
        Parallax.move_parallax();
    },
    scroll: function () {
        Parallax.move_parallax();
    },
    move_parallax: function () {

        $("[parallax]").each(function (i) {

            var _limit_top = Math.round($(this).offset().top - $(window).outerHeight());
            var _limit_bottom = Math.round($(this).offset().top + $(this).outerHeight());

            var _attenuation = 5;


            var _espace_visible = _limit_bottom - _limit_top;
            var _pos_scroll = Math.round((($(window).scrollTop() - _limit_top) / _espace_visible) * 100);

            //console.log("ESPACE : " + _espace + " | " + _pos_scroll + " | Espace visible : " + _espace_visible);

            var _decal_max = $(this).outerHeight() / _attenuation;


            if ((_pos_scroll > 0) && (_pos_scroll < 100)) {

                var _pos_block = ((_pos_scroll * Parallax.amplitude_mvt_block)/100);

                if ($(this).hasClass("parallax-block")) {


                    $(this).css({
                        "-webkit-transform":"translateY(" + (_pos_block - 50) +"px)",
                        "transform":"translateY(" + (_pos_block -50) +"px)",
                    })
                } else {

                    var _espace_dispo = Math.ceil($(this).find("img").outerHeight() - $(this).outerHeight());

                    if(_espace_dispo > 0){

                        var _scale_var = (_pos_scroll * Parallax.amplitude_scale) / 100;
                        var _scaleDest = (1 + Parallax.amplitude_scale) - _scale_var

                        var _translate = ((_espace_dispo * _pos_scroll) / 100) - _espace_dispo;

                        $(this).find("img").css({
                            transform: "translateY(" + _translate + "px) scale(" + _scaleDest + ")",
                            "-webkit-transform": "translateY(" + _translate + "px) scale(" + _scaleDest + ")"
                        });

                    }

                }

            }
        });
    }
}
$(window).on("load", function () {
    console.log("Parallax load : " + $("[parallax]").length);
    if ($(".akrolab-template [parallax]").length) {
        Parallax.init();
    }
})